'use client';
import CelebrateDialog from '@/components/Celebrate/celebrateDialog';
import CreateProjectDialog from '@/components/Projects/CreateProjectDialog';
import CreateVolunteeringDialog from '@/components/Volunteering/CreateVolunteeringDialog';
// import CreateVolunteeringDialog from '@/components/Volunteering/CreateVolunteeringDialog';
import CreateCampaignDialog from '@/components/next-page-components/CreateCampaignDialog/CreateCampaignDialog';
import CreateFundraiseDialog from '@/components/next-page-components/CreateFundraiseDialog/CreateFundraiseDialog';
import CreateCrowdFundingDialog from '@/components/next-page-components/CreateCrowdFundingDialog/CreateCrowdFundingDialog';
import CreatePostDialog from '@/components/next-page-components/CreatePostDialog/CreatePostDialog';
import PostType, { CampaignType } from '@/constants/postType.constants';
import {
  useIsCommunityAdmin,
  useIsCompanyAdmin,
  useIsNonProfitAdmin,
} from '@/hooks/useUser';
import React from 'react';
import { create } from 'zustand';
import CreateProjectMenuDialog from '@/components/Projects/CreateProjectMenuDialog';

export const useCreatePostsStore = create((set) => ({
  postType: null,
  open: false,
  message: null,
  supportedNonProfit: null,
  openDialog: (postType, message = null, supportedNonProfit = null) => {
    set({ open: true, postType, message, supportedNonProfit });
  },
  close: () => {
    set({
      open: false,
      postType: null,
      message: null,
      supportedNonProfit: null,
    });
  },
}));

function CreatePostDialogs() {
  const { postType, open, close, message, supportedNonProfit } =
    useCreatePostsStore();
  const isNonProfitAdmin = useIsNonProfitAdmin();
  const isCommunityAdmin = useIsCompanyAdmin();

  const handleClose = () => {
    close();
  };

  return (
    <div>
      <CreatePostDialog
        open={postType === PostType.UserPost && open}
        message={message}
        supportedNonProfit={supportedNonProfit}
        onClose={handleClose}
      />

      <CelebrateDialog onClose={handleClose} />

      {/* FundRaising */}
      <CreateCampaignDialog
        open={
          (postType === CampaignType.FundRaise ||
            postType === CampaignType.CollectGoods) &&
          open
        }
        type={postType}
        onClose={handleClose}
      />

      {isNonProfitAdmin && (
        <CreateVolunteeringDialog
          open={postType === PostType.Volunteering && open}
          onClose={handleClose}
        />
      )}

      {/* {isNonProfitAdmin && (
        <CreateProjectDialog
          open={postType === PostType.Project && open}
          onClose={handleClose}
        />
      )} */}

      {/* {isCommunityAdmin && (
        <CreateCrowdFundingDialog
          open={postType === PostType.CrowdFunding && open}
          onClose={handleClose}
        />
      )} */}

      <CreateFundraiseDialog
        open={
          (postType === PostType.Campaign ||
            postType === PostType.CrowdFunding) &&
          open
        }
        type={postType}
        onClose={handleClose}
      />

      {isNonProfitAdmin && (
        <CreateProjectMenuDialog
          open={postType === PostType.Project && open}
          onClose={handleClose}
        />
      )}
    </div>
  );
}

export default CreatePostDialogs;
